/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import {
  Alert,
  Button,
  Col,
  FormCheck,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { apiURL, fetchApi, postApi } from "../../../redux/api";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import WarningModal from "./WarningModal";
import { formatNumber } from "../../../redux/utils";
import { toast } from "react-hot-toast";
import { getSector } from "../../../redux/api";
import NewContractorForm from "../../sub-treasury/pv-collection/NewContractorForm";
import Attachment from "../../../components/Attachment";
import { PDFViewer } from "@react-pdf/renderer";
import RealiseCollectionPdf from "./ReleaseCollectionPDF";
// import { PaymentVoucherPdf } from "../../sub-treasury/pv-collection/PVPDF";
import moment from "moment-timezone";
import { Card, FormSelect } from "@themesberg/react-bootstrap";
import TaxItem from "../../sub-treasury/contractor-schedule/TaxItem";
import { PaymentVoucherPdf } from "../../sub-treasury/pv-collection/PVPDFNew";

export function getDistinctObjects(array, key1, key2) {
  return array?.filter(
    (obj, index, self) =>
      index ===
      self?.findIndex((o) => o[key1] === obj[key1] && o[key2] === obj[key2])
  );
}

export default function CapitalProject({ generalForm = {} }) {
  const mdaRef = useRef();
  const navigate = useNavigate();
  const user = useSelector((e) => e.auth.user);

  const [treasuryAccount, setTreasuryAccount] = useState([]);
  const [mdaAccount, setMdaAccount] = useState([]);
  const [budgetSummary, setBudgetSummary] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [taxesApplied, setTaxesApplied] = useState([]);
  const [pvList, setPvList] = useState([]);

  const [showAmountWarningModal, setShowAmountWarningModal] = useState(false);
  const [submittingReserveRequest, setSubmittingReserveRequest] =
    useState(false);
  const mda = useSelector((state) => state.auth.user);
  const imageId = moment().format("YYYYMMDDhhmmss");
  const newPVCode = Math.floor(Math.random() * 1000);

  const [form, setForm] = useState({
    date: moment().format("YYYY-MM-DD"),
    pv_code: newPVCode,
    projectType: "",
    paymentType: "",
    paymentClass: "",
    project_type: "",
    other_project_type: "",
    payment_type: "",
    other_payment_type: "",
    project_class: "",
    payment_class: "",
    mda_name: "",
    mda_code: "",
    destMdaCode: "",
    sourceMdaCode: "",
    mda_budget_balance1: "",
    sourceEconomicCode: "",
    sourceEconomicDescription: "",
    narration: "",
    // payment_type === "Power of Attorney" ? "Power of Attorney on behalf of" : "",
    fund_code: "",
    fund_description: "",
    functional_code: "",
    functional_description: "",
    program_code: "",
    program_description: "",
    project_description: "",
    geo_code: "",
    geo_description: "",
    contractor_phone: "",
    contractor_tin: "",
    contractor_email: "",
    contractor_address: "",
    account_name: "",
    bank_name: "",
    account_number: "",
    sort_code: "",
    query_type: "new_insert",
    approved_amount: "",
    reserveType: "",
    reserveStatus: "Pending",
    userId: user.username,
    pv_status: "Pending",
    approval_date: moment().format("YYYY-MM-DD"),
    imageId,
  });
  const [economicCode, setEconomicCode] = useState([]);
  const [economicCode1, setEconomicCode1] = useState([]);
  const [programCode, setProgramCode] = useState([]);
  const [geoCode, setGeoCode] = useState([]);
  const [funcCode, setFuncCode] = useState([]);
  const [fundCode, setFundCode] = useState([]);
  const [admin, setAdmin] = useState([]);
  const [taxesList, setTaxesList] = useState([]);
  const paymentTypes = ["Direct Payment", "Power of Attorney", "Others"];
  const projectTypes = ["Special Project", "Constituency Project", "Other"];
  const projectClassifications = [
    "Certificate Number",
    "APG Number",
    "Mobilization",
    "Retention",
    // "Land and Building",
    // "Plant and Machinery",
    // "Furniture and Fittings",
    "Others",
  ];
  const [projectDescription, setProjectDescription] = useState([]);

  const getData = (cb, type) => {
    getSector({ type }, "select", (d) => {
      cb(d);
    });
  };

  useEffect(() => {
    getData(setFuncCode, "FUNCTIONAL SEGMENT");
    getData(setProgramCode, "PROGRAMME SEGMENT");
    getData(setGeoCode, "GEO SEGMENT");
    getData(setFundCode, "FUND SEGMENT");
    getData(setAdmin, "ADMINISTRATIVE SEGMENT");
  }, []);

  const [showForm, setShowForm] = useState(true);

  const { acceptedFiles, getRootProps, getInputProps, isDragActive } =
    useDropzone({ accept: "image/*, .pdf, text/plain" });

  const getCCCopies = useCallback(() => {
    postApi(`post-cc?query_type=select_mda`, { mda_name: form.mda_name })
      .then((data) => {
        console.log("data", data);
        if (data.results) {
          setForm((p) => ({ ...p, copies: data.results[0] }));
          console.log("data", data.results[0]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [form.mda_name]);

  const getCCCopies1 = useCallback(() => {
    postApi(`post-cc?query_type=select_mda`, { mda_name: form.mda_head })
      .then((data) => {
        console.log("data", data);
        if (data.results) {
          setForm((p) => ({ ...p, copies1: data.results[0] }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [form.mda_head]);

  useEffect(() => {
    getCCCopies();
    getCCCopies1();
  }, [getCCCopies, getCCCopies1]);

  const getList = () => {
    getSector({ type: "mdas" }, "mdas", (d) => {
      setBudgetSummary(d);
    });
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    postApi(`select_mda_bank_details`, {
      query_type: "select",
    }).then((data) => {
      if (data.result && data.result.length) {
        console.log(data.result);

        const treasuryAccount = data.result.filter(
          (item) => item.account_type === "treasury_source_account"
        );
        setTreasuryAccount(treasuryAccount);

        const mdaAccount = data.result.filter(
          (item) => item.account_type === "mda_source_account"
        );
        setMdaAccount(mdaAccount);
      }
    });
  }, []);

  useEffect(() => {
    if (mda?.mda_name && mda?.mda_code) {
      setLoading(true);
      fetchApi(
        `get_new_pv_by_mda?query_type=select_head&mda_code=${mda.mda_code}`
      )
        .then((data) => {
          setPvList(data.result || []);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [mda]);

  useEffect(() => {
    if (mda?.mda_code) {
      setLoading(true);
      fetchApi(
        `get_new_pv_by_mda?query_type=get_project_description&mda_code=${mda.mda_code}`
      )
        .then((data) => {
          setProjectDescription(data.result || []);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [mda]);

  const handleChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    // alert(name)
    // if (name === "payment_type") {
      
    // }

    if (typeof value === "string" && value.includes("/")) {
      const [code, description] = value.split("/");

      // Update the form state with code and description separatel
      setForm((prevForm) => ({
        ...prevForm,
        [name]: code,
        [`${name}_description`]: description,
      }));
    } else {
      // If the value is not a string or doesn't contain a '/', update the form state normally
      setForm((prevForm) => ({
        ...prevForm,
        [name]: value,
      }));
    }
  };

  const handleChanges = (e) => {
    const { name, type, checked, value } = e.target;
    if (type === "checkbox") {
      setForm((prev) => ({ ...prev, [name]: checked ? value : "" }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const getList31 = useCallback(
    (economic_code) => {
      console.log(form);

      postApi(`update_budget_balance`, {
        query_type: "select",
        mda_name:
          form.projectType === "payable-to" ? form.mda_head : form.mda_name,
        mda_code:
          form.projectType === "payable-to"
            ? form.mda_head_code
            : form.mda_code,
        amount: null,
        economic_code: economic_code,
        geo_code: form.geo_code,
        program_code: form.program_code,
        functional_code: form.functional_code,
        fund_code: form.fund_code,
      })
        .then((d) => {
          console.log("data", d);
          if (d.success) {
            const selectedItem = d.data[0];
            setForm((p) => ({
              ...p,
              description: selectedItem?.budget_description,
              mda_budget_balance:
                selectedItem?.mopb_balance === 0
                  ? "Budget Exausted"
                  : selectedItem?.mopb_balance,
              budget:
                selectedItem?.approve_amount === 0
                  ? "Budget Exausted"
                  : selectedItem?.approve_amount,
            }));
          }
        })
        .catch((err) => {
          // Handle errors
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [
      form.functional_code,
      form.fund_code,
      form.geo_code,
      form.mda_code,
      form.mda_head,
      form.mda_head_code,
      form.mda_name,
      form.program_code,
      form.projectType,
    ]
  );

  const [newData, setNewdata] = useState();

  const handleEconomicCode = (selected) => {
    console.log(selected);
    // alert(JSON.stringify(selected));

    if (selected?.length) {
      // console.log("selected budget", selected);
      const selectedItem = selected[0];
      setNewdata(
        economicCode?.filter(
          (item) => item.economic_code === selectedItem.economic_code
        ) || []
      );
      setForm((p) => ({
        ...p,
        mda_economic_code: selectedItem.economic_code,
        economic_description: selectedItem.economic_description,
      }));
      getList31(selectedItem.economic_code);
      setForm((p) => ({ ...p, economic_code: selectedItem.economic_code }));
    } else {
      console.log("no item selected");
    }
  };

  const handleFundCode = (selected) => {
    console.log(selected);
    // alert(JSON.stringify(selected));

    if (selected?.length) {
      // console.log("selected budget", selected);
      const selectedItem = selected[0];
      setNewdata(
        economicCode?.filter(
          (item) => item.fund_code === selectedItem.fund_code
        ) || []
      );
      setForm((p) => ({
        ...p,
        fund_code: selectedItem.fund_code,
        fund_description: selectedItem.fund_description,
      }));
      setForm((p) => ({ ...p, fund_code: selectedItem.fund_code }));
    } else {
      console.log("no item selected");
    }
  };

  const handleFunctionalCode = (selected) => {
    console.log(selected);
    // alert(JSON.stringify(selected));

    if (selected?.length) {
      // console.log("selected budget", selected);
      const selectedItem = selected[0];
      setNewdata(
        economicCode?.filter(
          (item) => item.function_code === selectedItem.function_description
        ) || []
      );
      setForm((p) => ({
        ...p,
        functional_code: selectedItem.function_code,
        functional_description: selectedItem.function_description,
      }));
      setForm((p) => ({ ...p, function_code: selectedItem.function_code }));
    } else {
      console.log("no item selected");
    }
  };

  const handleGeoCode = (selected) => {
    console.log(selected);
    // alert(JSON.stringify(selected));

    if (selected?.length) {
      // console.log("selected budget", selected);
      const selectedItem = selected[0];
      setNewdata(
        economicCode?.filter(
          (item) => item.geo_code === selectedItem.geo_description
        ) || []
      );
      setForm((p) => ({
        ...p,
        geo_code: selectedItem.geo_code,
        geo_description: selectedItem.geo_description,
      }));
      setForm((p) => ({ ...p, geo_code: selectedItem.geo_code }));
    } else {
      console.log("no item selected");
    }
  };

  const handleHeadCode = (selected) => {
    console.log(selected);
    // alert(JSON.stringify(selected));

    if (selected?.length) {
      // console.log("selected budget", selected);
      const selectedItem = selected[0];
      setNewdata(
        pvList?.filter((item) => item.head === selectedItem.description) || []
      );
      setForm((p) => ({
        ...p,
        headCode: selectedItem.head,
        head_description: selectedItem.description,
      }));
      setForm((p) => ({ ...p, head: selectedItem.head }));
    } else {
      console.log("no item selected");
    }
  };

  const handleProjectDescription = (selected) => {
    console.log(selected);
    // alert(JSON.stringify(selected));

    if (selected?.length) {
      // console.log("selected budget", selected);
      const selectedItem = selected[0];
      setNewdata(
        projectDescription?.filter(
          (item) => item.description === selectedItem.description
        ) || []
      );
      setForm((p) => ({
        ...p,
        project_description: selectedItem.description,
        mda_economic_code: selectedItem.economic_code,
        economic_description: selectedItem.economic_description,
        fund_code: selectedItem.fund_code,
        fund_description: selectedItem.fund_description,
        function_code: selectedItem.function_code,
        function_description: selectedItem.function_description,
        program_code: selectedItem.program_code,
        program_description: selectedItem.program_description,
        geo_code: selectedItem.geo_code,
        geo_description: selectedItem.geo_description,
        // mda_budget_balance: selectedItem.budget_amount,
        narration: form.payment_type === "Power of Attorney" ? `${form.payment_type} on behalf of ${selectedItem.economic_description.toLowerCase()}` : `Being payment for  ${selectedItem.economic_description.toLowerCase()}`
      }));
    } else {
      console.log("no item selected");
    }
  };
  const handleApi = () => {
    console.log(
      "form.approved_amount",
      form.approved_amount,
      "form.mda_budget_balance",
      form.mda_budget_balance
    );
    if (
      parseFloat(form.approved_amount) > parseFloat(form.mda_budget_balance)
    ) {
      setShowAmountWarningModal(true);
    } else {
      setIsLoading(true);
      form.approval_type = "Capital";
      form.approved_by = "HE";
      form.approval_status = "Approval";
      form.mda_code = mda.mda_code;
      form.mda_name = mda.mda_name;

      // alert(JSON.stringify({ taxesApplied, form }));
      const mdaCode = mda.mda_code;

      // alert(JSON.stringify({ newPVCode }));

      postApi(`post_pv_collection_new`, { form, taxesApplied })
        .then((data) => {
          if (data.success) {
            console.log(data);
            handleApi1(data.approval_no);
            toast("Approval Submitted Successfully!", {
              appearance: "info",
              autoDismiss: true,
              autoDismissTimeout: 5000,
            });
            setShowForm(false);
          }
        })
        .catch((err) => {
          alert("");
          toast("An error occurred, please try again later.", {
            appearance: "error",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
          setShowForm(false);
        })
        .finally(() => {
          setIsLoading(false);
          setShowForm(false);
        });
    }
  };

  const handleApi1 = (approval_no) => {
    if (form.approved_amount && form.approved_amount !== "") {
      const formData = new FormData();
      form.approval_no = approval_no;
      for (let i = 0; i < acceptedFiles.length; i++) {
        formData.append("files", acceptedFiles[i]);
      }

      if (!acceptedFiles.length) {
        setForm((p) => ({ ...p, approval: "not approved" }));
        formData.append("form", JSON.stringify(form));

        fetch(`${apiURL}/post_images`, {
          method: "POST",

          body: formData,
        })
          .then((response) => response.json())
          .then((result) => {
            console.log(result);
          })

          .catch((err) => {
            console.log(err);
          });
      } else {
        formData.append("form", JSON.stringify(form));

        fetch(`${apiURL}/post_images`, {
          method: "POST",

          body: formData,
        })
          .then((response) => response.json())
          .then((result) => {
            console.log(result);
          })

          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      alert("Please enter a valid amount");
    }
  };

  const submitPlanningReserveRequest = () => {
    setIsLoading(true);
    // generalForm?.sent_to_mda = generalForm?.sent_to?.office || "";
    generalForm.sent_to_office = generalForm.sent_to.title || "";
    // form.query_type = "insert";
    // form.approval_type = "Capital";
    // form.approved_by = "HE";
    // form.approval_status = "Approval Released";
    const formData = {
      ...form,
      // query_type: "insert",
      approval_type: "Capital",
      approved_by: "HE",
      approval_status: "Approval Released",
      // mda_code: mda.mda_code,
      // mda_name: mda.mda_name,
    };
    postApi(`post_approval_collection`, { form })
      .then((data) => {
        if (data.success) {
          console.log(data);
          handleApi1(data.approval_no);
          // handleSubmitReset();
          alert("submit success");
          // setShowForm(false);
          postApi(`planning-reservation`, {
            // ...form,
            destMdaCode: selectedBudget.mda_code,
            destEconomicCode: selectedBudget.economic_code,
            destMdaDescription: selectedBudget.mda_name,
            destEconomicDescription: selectedBudget.description,
            destFundCode: selectedBudget.fund_code,
            destFundDescription: selectedBudget.fund_description,
            destFunctionalCode: selectedBudget.functional_code,
            destFunctionalDescription: selectedBudget.function_description,
            destProgramCode: selectedBudget.program_code,
            destProgramDescription: selectedBudget.program_description,
            destGeoCode: selectedBudget.geo_code,
            destGeoDescription: selectedBudget.geo_description,
            approvedAmount: form.approved_amount,
            // query_type: "insert",
            reserveStatus: "Pending",
            approvalNo: data.approval_no,
          })
            .then((data) => {
              if (data.success) {
                console.log(data);
                alert("submit success");
                // setShowForm(false);
                navigate("/planning-reservation");
              }
            })
            .catch((err) => {
              alert(err);
            })
            .finally(() => {
              setSubmittingReserveRequest(false);
            });
        }
      })
      .catch((err) => {
        alert(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getList31(form.mda_economic_code);
  }, [
    form.mda_name,
    form.economic_code,
    form.function_code,
    form.fund_code,
    form.geo_code,
    form.program_code,
    getList31,
    form.mda_economic_code,
  ]);

  useEffect(() => {
    postApi(`post_taxes`, {
      query_type: "select",
    })
      .then((data) => {
        if (data.result) {
          setTaxesList(data.result);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <>
      {showForm ? (
        <>
          <Row className="m-3">
            <Col md={4}>
              <FormLabel>Date</FormLabel>
              <FormControl
                type="date"
                value={form.approval_date}
                name="approval_date"
                onChange={handleChange}
              />
            </Col>
            <Col md={4}>
              <FormLabel>Project Type</FormLabel>
              <FormSelect
                id="exampleSelect"
                value={form.project_type}
                name="project_type"
                type="select"
                onChange={handleChange}
              >
                <option value="">Select................</option>
                {projectTypes.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </FormSelect>
            </Col>
            <Col md={4}>
              <FormLabel>Payment Type</FormLabel>
              <FormSelect
                value={form.payment_type}
                id="exampleSelect"
                name="payment_type"
                type="select"
                onChange={handleChange}
                options={paymentTypes}
              >
                <option value="">Select................</option>
                {paymentTypes.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </FormSelect>
            </Col>
            <Col md={4}>
              <FormLabel>Payment Classification</FormLabel>
              <FormSelect
                id="exampleSelect"
                value={form.project_class}
                name="project_class"
                type="select"
                onChange={handleChange}
                options={projectClassifications}
              >
                <option value="">Select................</option>
                {projectClassifications.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </FormSelect>
            </Col>
            <Col md={4}>
              <FormLabel>MDA Name</FormLabel>
              <FormControl type="text" disabled value={mda.mda_name} />
            </Col>
            <Col md={4}>
              <FormLabel>Admin Code</FormLabel>
              <FormControl
                type="text"
                value={mda.mda_code}
                // name="sourceMdaCode"
                // onChange={handleChange}
                disabled
              />
            </Col>
            <Col md={4}>
              <FormLabel style={{ display: "flex" }}>
                Select Departments (if any)
                {/* <span
                  style={{
                    // backgroundColor: "green",
                    borderRadius: 10,
                    display: "flex",
                    alignItems: "center",
                    textWrap: "nowrap",
                    fontSize: 12,
                    padding: 1,
                  }}
                  className="px-2 bg-success text-white"
                >
                  OR {" PAYABLE TO "}{" "}
                  <FormCheck
                    id="checkbox3"
                    type="checkbox"
                    style={{ fontSize: 15 }}
                    name="projectType"
                    value="payable-to"
                    checked={form.projectType === "payable-to"}
                    onChange={handleChanges}
                  />
                </span> */}
              </FormLabel>
              <Typeahead
                size="md"
                id="20"
                onChange={(selected) => handleHeadCode(selected)}
                // onInputChange={(text) => console.log(text)}
                options={pvList}
                labelKey={(option) => `${option.head} - ${option.description}`}
                placeholder="Select---"
                // ref={mdaRef}
              />
            </Col>
            <Col md={4}>
              <FormLabel>Project Description</FormLabel>
              <Typeahead
                size="md"
                id="20"
                onChange={(selected) => handleProjectDescription(selected)}
                options={projectDescription}
                labelKey={(option) => `${option.description}`}
                placeholder="Select---"
              />
            </Col>
            <Col md={4}>
              <FormLabel>Select Economic Code</FormLabel>
              <Typeahead
                size="md"
                id="20"
                onChange={(selected) => handleEconomicCode(selected)}
                options={economicCode}
                labelKey={(option) =>
                  `${option.economic_description} - ${option.economic_code}`
                }
                selected={
                  form.mda_economic_code
                    ? [
                        {
                          economic_description: form.economic_description,
                          economic_code: form.mda_economic_code,
                        },
                      ]
                    : []
                }
                placeholder="Select---"
              />
            </Col>
            <Col md={4}>
              <FormLabel>Economic Description</FormLabel>
              <FormControl
                type="text"
                value={form.economic_description}
                name="economic_description"
                onChange={handleChange}
                disabled
              />
            </Col>
            <Col md={4}>
              <FormLabel>Select Fund Code</FormLabel>
              <Typeahead
                size="md"
                id="20"
                onChange={(selected) => handleFundCode(selected)}
                options={economicCode}
                labelKey={(option) =>
                  `${option.fund_description} - ${option.fund_code}`
                }
                selected={
                  form.fund_code
                    ? [
                        {
                          fund_description: form.fund_description,
                          fund_code: form.fund_code,
                        },
                      ]
                    : []
                }
                placeholder="Select---"
              />
            </Col>
            <Col md={4}>
              <FormLabel>Fund Description</FormLabel>
              <FormControl
                type="text"
                value={form.fund_description}
                name="fund_description"
                onChange={handleChange}
                disabled
              />
            </Col>
            <Col md={4}>
              <FormLabel>Select Functional Code</FormLabel>
              <Typeahead
                size="md"
                id="20"
                onChange={(selected) => handleFunctionalCode(selected)}
                options={economicCode}
                labelKey={(option) =>
                  `${option.function_description} - ${option.function_code}`
                }
                selected={
                  form.function_code
                    ? [
                        {
                          function_description: form.function_description,
                          function_code: form.function_code,
                        },
                      ]
                    : []
                }
                placeholder="Select---"
              />
            </Col>
            <Col md={4}>
              <FormLabel>Functional Description</FormLabel>
              <FormControl
                type="text"
                value={form.function_description}
                name="function_description"
                onChange={handleChange}
                disabled
              />
            </Col>
            <Col md={4}>
              <FormLabel>Select Program Code</FormLabel>
              <Typeahead
                size="md"
                id="20"
                onChange={(selected) => {
                  if (selected && selected.length) {
                    handleChange({
                      target: {
                        name: "program_code",
                        value: selected[0].program_code,
                      },
                    });
                    setForm((p) => ({
                      ...p,
                      program_description: selected[0].program_description,
                    }));
                  }
                }}
                options={getDistinctObjects(
                  economicCode,
                  "program_code",
                  "program_description"
                )}
                labelKey={(option) =>
                  `${option.program_code}/${option.program_description}`
                }
                selected={
                  form.program_code
                    ? [
                        {
                          program_description: form.program_description,
                          program_code: form.program_code,
                        },
                      ]
                    : []
                }
                placeholder="Select---"
              />
            </Col>
            <Col md={4}>
              <FormLabel>Program Description</FormLabel>
              <FormControl
                type="text"
                value={form.program_description}
                name="program_description"
                onChange={handleChange}
                disabled
              />
            </Col>
            <Col md={4}>
              <FormLabel>Select Geo Code</FormLabel>
              <Typeahead
                size="md"
                id="20"
                onChange={(selected) => handleGeoCode(selected)}
                options={economicCode}
                labelKey={(option) =>
                  `${option.geo_description} - ${option.geo_code}`
                }
                selected={
                  form.geo_code
                    ? [
                        {
                          geo_description: form.geo_description,
                          geo_code: form.geo_code,
                        },
                      ]
                    : []
                }
                placeholder="Select---"
              />
            </Col>
            <Col md={4}>
              <FormLabel>Geo Description</FormLabel>
              <FormControl
                type="text"
                value={form.geo_description}
                name="geo_description"
                onChange={handleChange}
                disabled
              />
            </Col>
            <Col md={4}>
              <FormLabel>Budget Balance</FormLabel>
              <FormControl
                value={formatNumber(form.mda_budget_balance)}
                name="mda_budget_balance"
                onChange={handleChange}
                disabled
              />
            </Col>
            <Col md={4}>
              <FormLabel>Approved Budget Allocation</FormLabel>
              <FormControl
                value={formatNumber(form.mda_budget_balance)}
                name="mda_budget_balance"
                onChange={handleChange}
                disabled
              />
            </Col>
            <Col md={4}>
              <FormLabel>Amount {formatNumber(form.approved_amount)}</FormLabel>
              <FormControl
                type="number"
                value={form.approved_amount}
                name="approved_amount"
                onChange={handleChange}
              />
            </Col>
            {form.economic_code !== "" && form.mda_budget_balance === 0 ? (
              <Alert color="primary" className="mt-2">
                <center>Please select the corresponding line item</center>
              </Alert>
            ) : null}

            <Col md={12}>
              <FormLabel>Narration</FormLabel>
              <textarea
                className="coloum form-control"
                type="textarea"
                value={form.narration}
                name="narration"
                onChange={handleChange}
                rows={5}
              />
            </Col>

            <Col md={12} className="py-4 px-4">
              <Attachment
                acceptedFiles={acceptedFiles}
                getRootProps={getRootProps}
                getInputProps={getInputProps}
                isDragActive={isDragActive}
              />
            </Col>
            <Row>
              <NewContractorForm form={form} setForm={setForm} />
            </Row>
            <WarningModal
              showModal={showAmountWarningModal}
              setShowModal={setShowAmountWarningModal}
              handleSubmit={submitPlanningReserveRequest}
              form={form}
              loading={submittingReserveRequest}
            />
          </Row>
          <Card body className="my-2">
            <h6>Applicable Taxes</h6>
            <Row>
              {taxesList.map((item, index) => (
                <TaxItem
                  key={index}
                  index={index}
                  item={item}
                  form={form}
                  taxesApplied={taxesApplied}
                  setTaxesApplied={setTaxesApplied}
                />
              ))}
            </Row>
          </Card>
          <Row>
            <Col md={12} className="py-4 px-4">
              <center>
                <Button
                  className="mb-4"
                  onClick={handleApi}
                  disabled={isLoading}
                >
                  {isLoading ? "Please wait..." : "Submit"}
                </Button>
              </center>
            </Col>
          </Row>
        </>
      ) : (
        <>
          <PDFViewer height="1000" width="1000">
            <PaymentVoucherPdf form={form} taxesApplied={taxesApplied} />
          </PDFViewer>
        </>
      )}
    </>
  );
}